export enum SortType {
  ALPHABETICALLY = 'ALPHABETICALLY',
  BY_PROXIMITY = 'BY_PROXIMITY'
}
